import { render, staticRenderFns } from "./HealthActionHistory.vue?vue&type=template&id=1c89bba1"
import script from "./HealthActionHistory.vue?vue&type=script&lang=js"
export * from "./HealthActionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports